var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0073BB",
    d: "M107.131 1.228c-14.253.534-31.578 18.435-25.65 35.13 6.275 16.565 10.296 28.348 11.137 46.83 15.062-15.155 28.901-31.609 30.018-50.7.366-15.493-6.967-26.911-15.505-31.26zM69.549 70.012c-2.139 3.823-4.946 7.978-8.606 12.528-7.691 9.693-15.446 25.593-13.061 44.232 31.771-3.506 41.693-27.353 42.563-40.457-5.987-9.034-16.85-14.596-20.896-16.303zM5.477 12.815c-1.128 14.583 5.11 36.267 30.397 43.169 10.648 3.153 18.109 5.096 26.186 8.028 11.809 4.291 21.078 9.768 28.422 19.221-1.363-16.265-8.062-34.902-18.759-49.441-15.261-20.74-41.689-30.695-66.246-20.977z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c73462ef0156abec222bb313f3eb6571.svg";
export { ForwardRef as ReactComponent };